import { Link as GatsbyLink } from "gatsby";
import styled from "styled-components";

const Link = styled(GatsbyLink)`
  color: hsla(0, 0%, 0%, 0.6);
  text-decoration: none;
`;

export default Link;
